export const basicurl= "https://patient.stress.docsun.health";
export const backurl= "https://patient.basic.docsun.health";